var _style, _path, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-account_svg__Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".icon-account_svg__st0{fill:none;stroke:#050505;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon-account_svg__st0",
    d: "M20 22c0-5.5-3.6-10-8-10s-8 4.5-8 10"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "icon-account_svg__st0",
    cx: 11.9,
    cy: 5.2,
    r: 3
  })));
}

export default SvgIconAccount;